import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Input,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react';
import { createAlarmGroup, updateAlarmGroup } from '../api/alarm';

const AddAlarmGroupModalComponent = ({
  isOpen,
  onClose,
  refetchAlarmGroups, // refetch fonksiyonunu burada prop olarak alıyoruz
  alarmGroup = { id: '', name: '', description: '' },
  isEditMode = false,
  onSave,
}) => {
  const toast = useToast();
  const [groupDetails, setGroupDetails] = useState(
    {
      id: '',
      name: '',
      description: '',
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (isOpen) {
      setGroupDetails(alarmGroup);
    }
  }, [alarmGroup, isOpen]);

  const handleGroupChange = e => {
    const { name, value } = e.target;
    setGroupDetails(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    if (!groupDetails.name) {
      toast({
        title: 'Incomplete Data',
        description: 'Please provide a name for the group.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      if (isEditMode) {
        await updateAlarmGroup({ id: groupDetails.id, group: groupDetails });
        toast({
          title: 'Group Updated',
          description: 'The alarm group has been successfully updated.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        const { id, ...newGroupDetails } = groupDetails;
        await createAlarmGroup(newGroupDetails);
        toast({
          title: 'Group Created',
          description: 'The alarm group has been successfully created.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }

      refetchAlarmGroups(); // Başarılı işlemden sonra grupları yeniliyoruz
      onClose();
    } catch (error) {
      toast({
        title: isEditMode ? 'Failed to update group' : 'Failed to create group',
        description: error.toString(),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {isEditMode ? 'Edit Alarm Group' : 'Add Alarm Group'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap="4">
            <Flex align="center">
              <Text minWidth="120px">Name:</Text>
              <Input
                name="name"
                value={groupDetails.name}
                onChange={handleGroupChange}
                placeholder="Group Name"
              />
            </Flex>
            <Flex align="center">
              <Text minWidth="120px">Description:</Text>
              <Input
                name="description"
                value={groupDetails.description}
                onChange={handleGroupChange}
                placeholder="Group Description"
              />
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="green" onClick={handleSave}>
            {isEditMode ? 'Update' : 'Save'}
          </Button>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddAlarmGroupModalComponent;
